@if (event){
    <div class="relative my-3 border-slate-200 dark:border-slate-500 border bg-slate-100 dark:bg-slate-700 text-lrpTicketBlack dark:text-stone-300 rounded-xl p-4 shadow-md">
        <div class="flex justify-between text-lg px-4">
            <h2 class="cursor-pointer" [routerLink]="'/events/' + event.eventLink">{{event.eventHost.eventSystem.name }} {{ event.eventHost.display ? ' - ' + event.eventHost.name + ' ' : '' }} | {{ event.name }}</h2>
            @if (event.eventHost.eventSystem.img) {
                <a [routerLink]="'/system/' + event.eventHost.eventSystem.systemRef"><img class="hidden md:inline-block max-h-14 -mt-3" [src]="event.eventHost.eventSystem.img.url" alt=""></a>
            }
        </div>
        <div class="flex px-4 gap-5 mb-5 lg:mr-40">
            @if (event.image) {
                <div class=" bg-center bg-cover rounded-xl shadow-md shadow-lrpTicketBlack transition-transform ease-in-out duration-500" [ngClass]="expandedPanel ? 'md:min-w-36 md:min-h-36 md:max-h-36 md:max-w-36 min-w-16 min-h-16 max-h-16 max-w-16' : 'md:min-w-16 md:min-h-16 md:max-h-16 md:max-w-16'" style="background-image: url('{{ event.image.url}}');">
                    @if (event.eventHost.img) {
                        <img [src]="event.eventHost.img.url" class="w-20 my-1 mx-1 mix-blend-multiply hover:w-32 hover:mt-3 hover:ms-2" [alt]="event.eventHost.name">
                    }
                </div>
            }
            @else {
                <div class="md:min-w-36 md:min-h-36 md:max-h-36 md:max-w-36 min-w-16 min-h-16 max-h-16 max-w-16 p-4 rounded-xl shadow-md shadow-lrpTicketBlack">
                    @if (event.eventHost.img) {
                        <img [src]="event.eventHost.img.url" class="mix-blend-multiply" [alt]="event.eventHost.name">
                    }
                </div>
            }
            <div class="w-auto h-full">
                <p class="text-sm md:text-lg text-gray-400 md:-mt-2" i18n>
                    @if (event.eventStart == event.eventEnd) {
                        {{ event.eventStart | date:'shortDate' : 'en-GB'}}
                    }
                    @else if (event.eventStart != event.eventEnd) {
                        {{ event.eventStart | date:'shortDate' : 'en-GB'}} - {{ event.eventEnd | date:'shortDate' : 'en-GB'}}
                    }
                </p>
                <p class="text-sm md:text-md text-gray-400 md:-mt-2" i18n>
                    <a href="https://www.google.com/maps/search/?api=1&query={{ event.location }}">{{ event.location.split(',')[0] }}</a>
                </p>
                <div class="hidden md:block text-sm mt-3 transition-all overflow-hidden" [ngClass]="expandedPanel ? 'max-h-[600px]' : 'max-h-0'" [innerHTML]="event.promoDescription"></div>
            </div>
        </div>
        <div class="md:hidden text-sm mt-3 transition-all overflow-hidden" [ngClass]="expandedPanel ? 'max-h-[600px]' : 'max-h-0'" [innerHTML]="event.promoDescription"></div>
        @if (event.allowBookings && includeBookingLink) {
            <div class="bottom-8 right-8 md:-mt-10 mb-3 text-end">
                <button class="primaryButton" routerLink="/events/{{event.eventLink}}/book"><i class="pi pi-ticket"></i> Book Your Ticket</button>
            </div>
        }
        @if (includeBookingLink && (playerTickets || monsterTickets || staffTickets)) {
            <div class="overflow-hidden transition-all ease-in-out duration-500" [ngClass]="expandedPanel ? 'max-h-[600px]' : 'max-h-0'">
                <hr>
                <div class="grid mt-5 grid-cols-3 text-center text-sm">
                    @if (playerTickets) {
                        <div>
                            <p>Player Tickets</p>
                            @if (playerTickets.cost === 0){
                                <p class="text-xs italic">FREE</p>
                            }
                            @else {
                                <p class="text-xs">From {{ playerTickets.cost | currency:'GBP'  }}</p>
                            }
                        </div>
                    }
                    @if (monsterTickets){
                        <div>
                            <p>Monster Tickets</p>
                            @if (monsterTickets.cost === 0){
                                <p class="text-xs italic">FREE</p>
                            }
                            @else {
                                <p class="text-xs">From {{ monsterTickets.cost | currency:'GBP' }}</p>
                            }
                        </div>
                    }
                    @if (staffTickets){
                        <div>
                            <p>Staff Tickets</p>
                            @if (staffTickets.cost === 0){
                                <p class="text-xs italic">FREE</p>
                            }
                            @else {
                                <p class="text-xs">From {{ staffTickets.cost | currency:'GBP' }}</p>
                            }
                        </div>
                    }
                </div>
            </div>
        }
    </div>
}